function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "font-size: 0.75rem; line-height: 1rem;"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "font-size: 0.875rem; line-height: 1.25rem;"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "font-size: 1.125rem; line-height: 1.75rem;"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "font-size: 1.25rem; line-height: 1.75rem;"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "font-size: 1rem; line-height: 1.5rem;"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "font-size: 0.75rem; line-height: 1rem; font-weight: 500;"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "font-size: 0.875rem; line-height: 1.25rem; font-weight: 500;"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "font-size: 1.125rem; line-height: 1.75rem; font-weight: 600;"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "font-size: 1.25rem; line-height: 1.75rem; font-weight: 700;"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "font-size: 1rem; line-height: 1.5rem; font-weight: 600;"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "; // gap-2 -> 0.5rem\n  ",
        "; // Apply base font size to container\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: ",
        "; // Both layouts use column for the main info block\n  flex-grow: 1;\n  min-width: 0; // For text truncation\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 150px; // 이름 최대 너비 제한\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-right: 0.25rem; // mr-1 (stacked)\n  margin-left: 0.25rem; // ml-1 (inline)\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 120px; // UUID 최대 너비 제한\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  margin-left: 0.25rem; // ml-1\n  flex-shrink: 0;\n  // Base icon size (w-4 h-4) \n  width: 1em; // Use em for scaling with font size\n  height: 1em;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  color: var(--theme-info, ",
        "); // text-blue-500\n  \n  svg {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.125em; // Adjust alignment slightly\n  }\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  color: var(--theme-warning, ",
        "); // text-yellow-500\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n     &::before {\n        content: '\xb7';\n        margin: 0 0.25rem; // mx-1\n     }\n  "
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n    margin-left: 0.5rem; // ml-2\n     &::before {\n        content: '\xb7';\n        margin-right: 0.25rem;\n     }\n  "
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex; // Use inline-flex to keep dot and time together\n  align-items: center;\n  color: ",
        ";\n  white-space: nowrap;\n  \n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.25rem; // Add some space if children are present\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { css } from '@emotion/react';
// Size-based styles generator
var getSizeStyles = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'md';
    switch(size){
        case 'xs':
            return css(_templateObject()); // text-xs
        case 'sm':
            return css(_templateObject1()); // text-sm
        case 'lg':
            return css(_templateObject2()); // text-lg
        case 'xl':
            return css(_templateObject3()); // text-xl
        case 'md':
        default:
            return css(_templateObject4()); // text-base
    }
};
var getNameSizeStyles = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'md';
    switch(size){
        case 'xs':
            return css(_templateObject5()); // text-xs font-medium
        case 'sm':
            return css(_templateObject6()); // text-sm font-medium
        case 'lg':
            return css(_templateObject7()); // text-lg font-semibold
        case 'xl':
            return css(_templateObject8()); // text-xl font-bold
        case 'md':
        default:
            return css(_templateObject9()); // text-base font-semibold
    }
};
// Container Styles
export var AuthorContainer = styled.div(_templateObject10(), function(param) {
    var hideAvatar = param.hideAvatar;
    return hideAvatar ? '0' : '0.5rem';
}, function(param) {
    var size = param.size;
    return getSizeStyles(size);
}, function(param) {
    var variant = param.variant, theme = param.theme;
    return variant === 'inverse' ? '#d1d7dc' // 어두운 배경용 보조 텍스트 색상 (Timestamp 등)
     : (theme === null || theme === void 0 ? void 0 : theme.text) || 'var(--theme-text)';
});
export var AvatarWrapper = styled.div(_templateObject11());
export var InfoContainer = styled.div(_templateObject12(), function(param) {
    var layout = param.layout;
    return layout === 'stacked' ? 'column' : 'column';
});
export var NameContainer = styled.div(_templateObject13());
export var NameText = styled.span(_templateObject14(), function(param) {
    var size = param.size;
    return getNameSizeStyles(size);
}, function(param) {
    var variant = param.variant, theme = param.theme;
    return variant === 'inverse' ? '#ffffff' // 어두운 배경용 주 텍스트 색상 (흰색)
     : (theme === null || theme === void 0 ? void 0 : theme.text) || 'var(--theme-text)';
});
export var UsernameText = styled.span(_templateObject15(), function(param) {
    var size = param.size;
    return getSizeStyles(size);
}, function(param) {
    var variant = param.variant, theme = param.theme;
    return variant === 'inverse' ? '#adb5bd' // 어두운 배경용 약간 어두운 보조 색상
     : (theme === null || theme === void 0 ? void 0 : theme.textSecondary) || 'var(--theme-text-secondary, #6b7280)';
});
// Shared styles for icons
var IconStyle = css(_templateObject16());
export var VerifiedIcon = styled.span(_templateObject17(), IconStyle, function(param) {
    var theme = param.theme;
    return theme.info || '#3B82F6';
});
export var FeaturedIcon = styled.span(_templateObject18(), IconStyle, function(param) {
    var theme = param.theme;
    return theme.warning || '#F59E0B';
});
export var TimestampWrapper = styled.span(_templateObject21(), function(param) {
    var variant = param.variant, theme = param.theme;
    return variant === 'inverse' ? '#d1d7dc' // 어두운 배경용 보조 텍스트 색상
     : (theme === null || theme === void 0 ? void 0 : theme.textSecondary) || 'var(--theme-text-secondary, #6b7280)';
}, function(param) {
    var layout = param.layout, hasUsername = param.hasUsername;
    return layout === 'stacked' && hasUsername && css(_templateObject19());
}, function(param) {
    var layout = param.layout;
    return layout === 'inline' && css(_templateObject20());
});
export var AdditionalContentWrapper = styled.div(_templateObject22());
